const ADDRESS_PREFIX = '@@address/';

export const ADDRESS_ACTION_TYPES = {
    SET_ADDRESS_FIELDS: `${ADDRESS_PREFIX}SET_ADDRESS_FIELDS`,
    REQUEST_COUNTRIES: `${ADDRESS_PREFIX}REQUEST_COUNTRIES`,
    RECEIVE_COUNTRIES: `${ADDRESS_PREFIX}RECEIVE_COUNTRIES`,
};

export const ADDRESS_FIELD_NAMES = {
    FIRSTNAME: 'firstName',
    LASTNAME: 'lastName',
    PHONE_COUNTRY: 'countryPhoneCode',
    PHONE: 'phone',
    EMAIL: 'email',
    IS_JURIDIC: 'isJuridic',

    COMPANY: 'companyName',
    COMPANY_INN: 'companyInn',
    COMPANY_KPP: 'companyKpp',
    COMPANY_OGRN: 'companyOgrn',
    COMPANY_CHIEF_NAME: 'companyChiefName',
    COMPANY_CONTACT_NAME: 'companyContactName',
    COMPANY_JOB_TITLE: 'companyJobTitle',
    COMPANY_SCOPE: 'companyScope',
    COMPANY_LEGAL_ADDR: 'companyLegalAddress',
    COMPANY_POST_ADDR: 'companyPostAddress',
};